import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import AskAIChat from "./AskAIChat";
import { Toaster } from "sonner";

export default function Layout() {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="App min-h-screen bg-ivory text-navy" data-testid="app-layout">
      <Header />
      <main className="relative" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <AskAIChat />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A1128",
            color: "#FDFBF7",
            border: "1px solid #C5A059",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}
